<template>
  <div class="vuetable-filterbar col-md-12 step-filtrar">
    <div class="form-group">
      <b-container fluid>
        <b-row no-gutters>
          <b-col sm="6" md="2" class="p-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                ref="numFiscalInput"
                type="text"
                class="form-control"
                v-model="num_fiscal"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Nº Fiscal NFe</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="2" class="p-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_fiscal_doc"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Nº Cte</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="3" class="p-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="emi_cnpj"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >CPNJ Emitente</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="2" class="p-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="chave"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Chave NFe</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="3" class="p-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="usuario_inc"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Email de Usuário Inclusão</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="2" class="p-0">
            <b-form-datepicker
              locale="pt-br"
              placeholder="Data Emissão Inicial"
              reset-button
              v-model="dt_inicio"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-0">
            <b-form-datepicker
              locale="pt-br"
              placeholder="Data Emissão Fim"
              reset-button
              v-model="dt_fim"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>

          <b-col sm="6" md="2" class="p-0">
            <b-form-datepicker
              locale="pt-br"
              placeholder="Data Inclusão Inicial"
              reset-button
              v-model="dt_inc_inicio"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-0">
            <b-form-datepicker
              locale="pt-br"
              placeholder="Data Inclusão Fim"
              reset-button
              v-model="dt_inc_fim"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>

          <b-col sm="6" md="2" class="p-0">
            <b-form-datepicker
              locale="pt-br"
              placeholder="Data Previsão Inicial"
              reset-button
              v-model="dt_pre_inicio"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-0">
            <b-form-datepicker
              locale="pt-br"
              placeholder="Data Previsão Fim"
              reset-button
              v-model="dt_pre_fim"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>


          <b-col sm="6" md="5" class="p-a-0 m-t-5px">
            <multiselect
              v-model="fornecedor"
              :options-limit="300"
              :limit="2"
              :limit-text="limitText"
              :options="optionsFornecedor"
              track-by="value"
              label="label"
              id="fornecedor"
              :hide-selected="true"
              placeholder="Redespacho ( Digite 3 caracteres para pesquisar )"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
              :searchable="true"
              :loading="isLoadingFornecedor"
              @search-change="listaFornecedor"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-0">
            <b-container>
              <b-col sm="12" md="12" >
                <b-form-checkbox
                  v-model="ocultar"
                  value="1"
                  unchecked-value="2"
                  v-if="getPermissionFw('gerardoc.ocultar')"
                >
                  Ocultados
                  <span
                    v-b-tooltip
                    title="Se marcado irá retornar documentos ocultados na listagem"
                    placement="top"
                    >[?]</span
                  >
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="utilizadas"
                  value="1"
                  unchecked-value="2"
                >
                  Utilizadas
                  <span
                    v-b-tooltip
                    title="Se marcado irá retornar documentos que já tiveram CTE emitido"
                    placement="top"
                    >[?]</span
                  >
                </b-form-checkbox>
                <b-form-checkbox
                    v-model="canceladas"
                    value="1"
                    unchecked-value="2"
                >
                  Docs. Cancelados
                  <span
                      v-b-tooltip
                      title="Se marcado irá retornar NFs que já tiveram Documentos cancelados"
                      placement="top"
                  >[?]</span
                  >
                </b-form-checkbox>
                <b-form-checkbox
                    v-model="nfs_canceladas"
                    value="1"
                    unchecked-value="2"
                >
                  NFs. Canceladas
                  <span
                      v-b-tooltip
                      title="Se marcado irá retornar NFs com ocorrências de cancelamento"
                      placement="top"
                  >[?]</span
                  >
                </b-form-checkbox>

                <b-form-checkbox
                    v-model="nfe_reversa"
                    value="1"
                    unchecked-value="2"
                >
                  NFe Reversa
                  <span
                      v-b-tooltip
                      title="Se marcado irá retornar todas as NFs que não tenham lote"
                      placement="top"
                  >[?]</span
                  >
                </b-form-checkbox>
                <b-form-checkbox
                    v-model="redespacho"
                    value="1"
                    unchecked-value="2"
                >
                  Redespacho
                  <span
                      v-b-tooltip
                      title="Se marcado irá retornar apenas notas de redespacho"
                      placement="top"
                  >[?]</span>
                </b-form-checkbox>
              </b-col>
            </b-container>
          </b-col>

          <b-col class="p-0 pt-1">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="!hasRequiredFilters()"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="!hasRequiredFilters()"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import { formatCNPJFromParts } from "../utils";

export default {
  data() {
    return {
      date_attributes: [{ key: "today", highlight: true, dates: new Date() }],
      isLoadingFornecedor: false,
      num_fiscal: "",
      num_fiscal_doc: "",
      emi_cnpj: "",
      chave: "",
      dt_inc_inicio: "",
      dt_inc_fim: "",
      dt_inc_inicio_label: "",
      dt_inc_fim_label: "",
      dt_pre_inicio_label: "",
      dt_pre_fim_label: "",
      dt_inicio: "",
      dt_pre_inicio: "",
      dt_pre_fim: "",
      usuario_inc: "",
      dt_fim: "",
      fornecedor: "",
      ocultar: "",
      utilizadas: "",
      canceladas: "",
      nfs_canceladas: "",
      nfe_reversa: "",
      redespacho: "",
      optionsFornecedor: [],
      data_filter: [],
      helpForm: new Form({ statusRecord: [], params: [], search:"" }),
    };
  },
  mounted() {
    // A filterbar vive sob v-if e e remontada a cada exibicao: o listener
    // precisa ser removido no beforeDestroy para nao acumular. Ver TMS-8259.
    this.$events.$on("gerardoc:focus-num-fiscal", this.focusNumFiscal);
  },
  beforeDestroy() {
    this.$events.$off("gerardoc:focus-num-fiscal", this.focusNumFiscal);
  },
  methods: {
    focusNumFiscal() {
      const input = this.$refs.numFiscalInput;
      if (!input) {
        return;
      }
      input.focus();
      if (typeof input.select === "function") {
        input.select();
      }
    },
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.dt_inicio_label = this.dt_inicio;
      this.dt_fim_label = this.dt_fim;
      this.dt_inicio = this.formatDateSubmit(this.dt_inicio);
      this.dt_fim = this.formatDateSubmit(this.dt_fim);
      this.dt_inc_inicio_label = this.dt_inc_inicio;
      this.dt_inc_fim_label = this.dt_inc_fim;
      this.dt_pre_inicio_label = this.dt_pre_inicio;
      this.dt_pre_fim_label = this.dt_pre_fim;
      this.dt_inc_inicio = this.formatDateSubmit(this.dt_inc_inicio);
      this.dt_inc_fim = this.formatDateSubmit(this.dt_inc_fim);
      this.dt_pre_inicio = this.formatDateSubmit(this.dt_pre_inicio);
      this.dt_pre_fim = this.formatDateSubmit(this.dt_pre_fim);
      this.data_filter = {
        num_fiscal: this.num_fiscal,
        num_fiscal_doc: this.num_fiscal_doc,
        chave: this.chave,
        usuario_inc: this.usuario_inc,
        ocultar: this.ocultar,
        fornecedor: this.fornecedor,
        utilizadas: this.utilizadas,
        canceladas: this.canceladas,
        nfs_canceladas: this.nfs_canceladas,
        emi_cnpj: this.emi_cnpj,
        dt_inc_inicio: this.dt_inc_inicio,
        dt_inc_fim: this.dt_inc_fim,
        dt_pre_inicio: this.dt_pre_inicio,
        dt_pre_fim: this.dt_pre_fim,
        dt_inicio: this.dt_inicio,
        dt_fim: this.dt_fim,
        nfe_reversa: this.nfe_reversa,
        redespacho: this.redespacho,
      };
      this.$events.fire("filter-set", this.data_filter);
      this.dt_inicio = this.dt_inicio_label;
      this.dt_fim = this.dt_fim_label;
      this.dt_inc_inicio = this.dt_inc_inicio_label;
      this.dt_inc_fim = this.dt_inc_fim_label;
      this.dt_pre_inicio = this.dt_pre_inicio_label;
      this.dt_pre_fim = this.dt_pre_fim_label;
    },
    resetFilter() {
      this.num_fiscal = ""; // clear the text in text input
      this.emi_cnpj = "";
      this.num_fiscal_doc = "";
      this.chave = "";
      this.usuario_inc = "";
      this.ocultar = "";
      this.utilizadas = "";
      this.canceladas = "";
      this.nfs_canceladas = "";
      this.dt_inc_inicio = "";
      this.dt_inc_fim = "";
      this.dt_pre_inicio = "";
      this.dt_pre_fim = "";
      this.dt_inicio = "";
      this.dt_fim = "";
      this.nfe_reversa = "";
      this.fornecedor = "";
      this.redespacho = "";
    },
    listaFornecedor(search) {
      if (search.length >= 3) {
        this.isLoadingFornecedor = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/fornecedor")
          .then((response) => {
            this.optionsFornecedor = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                this.optionsFornecedor.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                this.optionsFornecedor.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsFornecedor.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            this.isLoadingFornecedor = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    hasRequiredFilters() {
      return [
        this.num_fiscal,
        this.num_fiscal_doc,
        this.chave,
        this.usuario_inc,
        this.ocultar,
        this.utilizadas,
        this.canceladas,
        this.nfs_canceladas,
        this.dt_inc_inicio,
        this.dt_inc_fim,
        this.dt_pre_inicio,
        this.dt_pre_fim,
        this.dt_inicio,
        this.dt_fim,
        this.nfe_reversa,
        this.fornecedor,
        this.emi_cnpj,
        this.redespacho,
      ].some(value =>
        Array.isArray(value) ? value.length > 0 :
        typeof value === "string" ? value.trim() !== "" :
        value !== null && value !== undefined
      );
    },
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      },
    },
  },
};
</script>